import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '*',
		name: 'NotFound',
		component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes
});

export default router;
